﻿export class response_login_payment {
    public method: string | null = null;
    public description: string | null = null;
    public nett_gross: string | null = null;
    public provider: string | null = null;
}